module.exports = __webpack_public_path__ + "img/iosTip.40ce99e6.png";